import {Component, OnInit, ChangeDetectorRef, ChangeDetectionStrategy} from '@angular/core';
import {NewsService} from '../../../shared/services/news.service';
import {AppLoadingEventsEmitter} from '../../../shared/events/loading.events';
import {Constants} from '../../../shared/config/constants.config';
import {Router} from '@angular/router';
import {RecipeListViewModalModel} from '../../../shared/viewModels/recipe.viewModel';
import {ProductsService} from '../../../shared/services/products.service';
import {AddRecipeFilterModalComponent} from '../../../meals/components/modals/add-recipe-filter/add-recipe-filter.component';
import {BsModalRef, BsModalService} from 'ngx-bootstrap';
import {BsModalEventsEmitter} from '../../../shared/events/bsModal.events';
import {RecipesFilterModalComponent} from '../recipes-filter/recipes-filter.component';

@Component({
    selector: 'app-recipes',
    templateUrl: './recipes.component.html',
    styleUrls: ['./recipes.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class RecipesComponent implements OnInit {
    skip = 0;
    hasMore = false;

    bsModalRef: BsModalRef;
    recipes: RecipeListViewModalModel[] = [];

    selectedAttributeOptionIds = [];
    selectedCategoryIds = [];

    hasVideo = false;
    mealPrepFriendly = false;

    constructor(
        private readonly productsService: ProductsService,
        private readonly changeDetectorRef: ChangeDetectorRef,
        private readonly appLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly constants: Constants,
        private readonly bsModalService: BsModalService,
        private readonly bsModalEventsEmitter: BsModalEventsEmitter,
        public readonly router: Router,
    ) {
    }

    ngOnInit() {
        this.loadMore();
    }

    loadMore() {
        this.appLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.productsService.getListRecipes(
            this.skip,
            this.selectedCategoryIds,
            this.selectedAttributeOptionIds,
            this.hasVideo,
            this.mealPrepFriendly
        ).subscribe(recipes => {
            recipes.results.map(item => {
                this.recipes.push(item);
            });

            this.skip += recipes.skipped;
            this.hasMore = recipes.results.length >= 8;

            this.appLoadingEventsEmitter.broadcastAppIsLoading(false);
            this.changeDetectorRef.markForCheck();
        });
    }

    openFilter(e: Event) {
        e.stopPropagation();
        e.stopImmediatePropagation();

        this.bsModalRef = this.bsModalService.show(RecipesFilterModalComponent, {
            backdrop: true
        });

        this.bsModalRef.content.recipesComponent = this;

        this.bsModalEventsEmitter.broadcastBsModalStateChanged(this.bsModalRef);
    }

    reload() {
        this.skip = 0;
        this.recipes = [];
        this.loadMore();
    }

}
